import { Box } from '@mui/material'
import React, { useState } from 'react'
import MButton from './MButton'
import { excelConfig, filterHeaderXlDataStyle, filterHeaderXlStyle, processExcel } from '../utils/ExcelExport'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, generateDynamicColumnStyles, jsPdfDidParseCellCallback, jsPDFHeader, jsPdfHeaderFooter, jsPdfWillDrawCellCallback } from '../utils/PrintExport'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../assets/fonts/Roboto-bold'
import { callAddFontRobotoNormal } from '../assets/fonts/Roboto-normal'
import { useSelector } from 'react-redux'
import autoTable from 'jspdf-autotable'
import Excel from 'exceljs'
import FileSaver from 'file-saver'

const ExcelAndPrint = (props) => {
    const {
        reportTitle = 'Report Name',
        filterSectionData = {},
        filterSectionColumn = [],
        isLandscapeCol = 12,
        showHead = 'everyPage',
        filterColSlice = null,
        multiTable = []
    } = props
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;

    const getFilterSectionData = () => {
        return {
            filterHeaderXlStyle,
            filterHeaderXlDataStyle,
            filterData: [
                {
                    columns: filterSectionColumn,
                    data: [
                        filterSectionData,
                    ]
                }
            ]
        }
    }
    const printReport = (isSave = false) => {
        try {
            const filterSectionData = getFilterSectionData();

            const tableWidth = calculateTotalTableWidth(multiTable?.[0].columnDef);
            const isLandscape = multiTable?.[0].columnDef.length > isLandscapeCol;

            const [baseWidth, baseHeight] = isLandscape
                ? calculateDynamicFormatLandscape(Math.max(tableWidth, 1122) + 60)
                : calculateDynamicFormatPortrait(Math.max(tableWidth, 900) + 60);

            const orientation = isLandscape ? 'l' : 'p';

            const pageWidth = isLandscape ? 1122 : 793;
            const pageHeight = isLandscape ? 793 : 1122;


            const scale = Math.max(
                Math.min(pageWidth / baseWidth, pageHeight / baseHeight),
                0.6
            );
            const fontSize = 14 * scale;
            const margin = { top: 10 * scale, left: 10 * scale, right: 10 * scale, bottom: 20 * scale };
            const startY = 50 * scale;
            const cellPadding = 6 * scale;
            const minCellHeight = 36 * scale;
            const lineWidth = 0.2 * scale;

            let rowColor = [191, 225, 255]



            // Add fonts
            jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
            jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

            // Create PDF
            const doc = new jsPDF({
                orientation,
                format: [baseWidth, baseHeight],
                unit: 'px',
                compress: true
            });

            const totalPagesExp = `{total_pages_count_string}`;

            // autoTable.setDefaults({
            //     headStyles: { fontSize: 9 * scale, halign: 'left', fillColor: [30, 89, 167] },
            // });

            const fileName = reportTitle.replace(/\s+/g, '');
            doc.setProperties({
                title: `${fileName}.pdf`,
                subject: reportTitle,
                author: "Maven Tech Labs Pvt. Ltd.",
                keywords: "maven tech, BusCRS, agent voucher",
                creator: "MTLPL",
            });

            // Dynamic column styles

            let currentY = startY;
            let numberCol = filterColSlice !== null ? filterColSlice : filterSectionColumn.length
            for (let i = 0; i < filterSectionColumn.length; i += numberCol) {
                const filterCol = filterSectionColumn.slice(i, i + numberCol);
                const columnStyles = {};
                filterCol.forEach((col, index) => {
                    columnStyles[index] = {
                        fontSize,
                        textColor: [0, 0, 0],
                        cellPadding,
                        minCellHeight,
                        valign: 'middle',
                        font: 'Roboto',
                        halign: 'left',
                        fontStyle: 'normal',
                        lineWidth
                    };
                });

                autoTable(doc, {
                    margin: i === 0 ? { ...margin } : { ...margin, top: 0 },
                    tableWidth: 'auto',
                    columns: filterCol,
                    body: filterSectionData.filterData[0].data,
                    startY: currentY,

                    theme: 'grid',
                    headStyles: {
                        fillColor: rowColor,
                        textColor: [0, 0, 0],
                        minCellHeight,
                        valign: 'middle',
                        cellPadding,
                        fontSize,
                        font: 'Roboto',
                        fontStyle: 'bold',
                        lineWidth,
                    },
                    columnStyles,
                });
                currentY = doc.lastAutoTable.finalY;

            }



            const minCellDataHeight = 32 * scale;
            let fontSizeData = 12 * scale;
            let lastRenderedPage = 0;

            multiTable.forEach((tableConfig, idx) => {
                const { columnDef = [], body = [], titleTable = '' } = tableConfig
                const pdfColumns = columnDef.map((col) => ({
                    header: col.headerName,
                    dataKey: col.field,
                    xlCol: col.xlCol
                }));
                if (titleTable?.trim() !== '') {
                    doc.setFont('Roboto', 'bold')
                    doc.text(titleTable, 10 * scale, idx === 0 ? currentY + 20 : currentY + 10)
                    currentY += idx === 0 ? 10 : 20
                }
                autoTable(doc, {
                    startY: idx === 0 ? currentY + 20 : currentY,
                    margin: idx === 0 ? { ...margin, top: (10 * scale) + (40 * scale) } : { ...margin, top: (10 * scale) + (40 * scale) },
                    tableWidth: 'auto',
                    columns: pdfColumns,
                    body: body,
                    columnStyles: generateDynamicColumnStyles(columnDef, fontSizeData, minCellDataHeight, cellPadding),
                    theme: 'grid',
                    headStyles: {
                        fillColor: rowColor,
                        textColor: [0, 0, 0],
                        minCellHeight: minCellDataHeight,
                        valign: 'middle',
                        cellPadding,
                        fontSize: fontSizeData,
                        font: 'Roboto',
                        fontStyle: 'bold',
                        lineWidth,
                    },
                    rowPageBreak: 'avoid',
                    didParseCell: (data) => {
                        jsPdfDidParseCellCallback(data, pdfColumns, [], fontSizeData);
                    },
                    willDrawCell: (data) => {
                        jsPdfWillDrawCellCallback(data, false, '', fontSizeData);
                    },

                    showHead: showHead,
                    didDrawPage: function (data) {
                        const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                        if (currentPage !== lastRenderedPage) {
                            lastRenderedPage = currentPage;
                            jsPDFHeader(doc, "CompanyName", "CompanyID", reportTitle, scale, baseWidth);
                            jsPdfHeaderFooter(data, userDetails, totalPagesExp, scale, baseHeight, baseWidth)
                        }
                    }
                })
                currentY = doc.lastAutoTable.finalY + (20 * scale);
            })




            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            if (isSave) {
                doc.save(`${fileName}.pdf`);
            } else {


                const blob = doc.output("blob");
                const blobUrl = URL.createObjectURL(blob);

                const iframe = document.createElement('iframe');
                iframe.style.display = 'none'; // hidden

                iframe.src = blobUrl;
                document.body.appendChild(iframe);

                iframe.onload = () => iframe.contentWindow.print();
            }

        }
        catch (error) {
            console.log("Error: ", error);

        }
    };

    const excelExport = async () => {
        try {
            const fileName = `${reportTitle.replace(/\s+/g, '') || 'Xl_Export'}.xlsx`;
            const workbook = new Excel.Workbook();
            let worksheet = workbook.addWorksheet(reportTitle || 'Sheet 1', {
                headerFooter: {
                    firstHeader: reportTitle,
                    firstFooter: reportTitle
                }
            });
            const filterSectionData = getFilterSectionData();

            let currentRow = 1;

            multiTable.forEach(async (tableConfig, index) => {
                const xlColumns = tableConfig.columnDef.map(col => ({
                    colHeader: col.headerName,
                    field: col.field,
                    xlCol: col.xlCol
                }));
                const xlConfig = {
                    ...excelConfig,
                    columns: xlColumns,
                    fileName,
                    showFilterSection: index === 0,
                    filterSectionData,
                    showSummarySection: false,
                    showEmptyRow: true,
                    showHeader: true,
                    workSheetTitle: reportTitle,
                    headerRowStyle: { fill: 'FF1E59A7', bold: true, font: 14 },
                    borderStyle: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    },
                    headerFooter: {
                        firstHeader: reportTitle,
                        firstFooter: reportTitle
                    },
                    sheetHeaderData: index === 0 ? [
                        {
                            "caption": reportTitle,
                            "colSpan": xlColumns.length,
                            "horizontal": "center",
                            "newRow": true
                        },] : []
                };
                const result = await processExcel(worksheet, { ...xlConfig, startRow: currentRow }, tableConfig.body || [], tableConfig.summaryData || []);
                worksheet = result.worksheet;
                currentRow = result.currentRow + 2;
            })

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            FileSaver.saveAs(blob, fileName);
        } catch (err) {
            console.error('Excel export failed:', err);
        }
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
            <MButton variant='outlined' btnName="Export As Excel" onClick={excelExport} />
            <MButton variant='outlined' btnName="Export As PDF" onClick={() => {
                printReport(true)
            }} />
            <MButton variant='outlined' btnName="Print" onClick={() => {
                printReport()
            }} />
        </Box>
    )
}

export default ExcelAndPrint